import axios from "axios";
import { errorMessage } from "../errorHandle";
import { APP_URL } from "../../config/api";


export const createTrainerCertificate = (cred) => {
    return (dispatch) => {
      dispatch({
        type: TRAINER_CERTIFICATE.REQUEST,
      });
      axios
        .request({
          method: "post",
          url: `${APP_URL}/add-trainer-certificate`,
          data: cred,
        })
        .then((res) => {
          dispatch({
            type: TRAINER_CERTIFICATE.ADD_TRAINER_CERTIFICATE,
            payload: res.data,
          });
        })
        .catch((error) => {
          dispatch(errorMessage(error, TRAINER_CERTIFICATE.ERROR));
        });
    };
  };

  export const getSkills = (cred) => {
    return (dispatch) => {
      dispatch({
        type: TRAINER_CERTIFICATE.REQUEST,
      });
      axios
        .request({
          method: "post",
          url: `${APP_URL}/get-skills`,
          data: cred,
        })
        .then((res) => {
          dispatch({
            type: TRAINER_CERTIFICATE.GET_SKILL,
            payload: res.data,
          });
        })
        .catch((error) => {
          dispatch(errorMessage(error, TRAINER_CERTIFICATE.ERROR));
        });
    };
  };
  
  export const getAllTrainerCertificate = (cred) => {
    return (dispatch) => {
      dispatch({
        type: TRAINER_CERTIFICATE.REQUEST,
      });
      axios
        .request({
          method: "post",
          url: `${APP_URL}/trainer-certificate-list`,
          data: cred,
        })
        .then((res) => {
          dispatch({
            type: TRAINER_CERTIFICATE.GET_LIST_TRAINER_CERTIFICATE,
            payload: res.data,
          });
        })
        .catch((error) => {
          dispatch(errorMessage(error, TRAINER_CERTIFICATE.ERROR));
        });
    };
  };
  
  export const deleteTrainerCertificate = (cred) => {
    return (dispatch) => {
      dispatch({
        type: TRAINER_CERTIFICATE.REQUEST,
      });
      axios
        .request({
          method: "post",
          url: `${APP_URL}/delete-trainer-certificate`,
          data: cred,
        })
        .then((res) => {
          dispatch({
            type: TRAINER_CERTIFICATE.TRAINER_CERTIFICATE_DELETE,
            payload: res.data.list,
          });
        })
        .catch((error) => {
          dispatch(errorMessage(error, TRAINER_CERTIFICATE.ERROR));
        });
    };
  };
  
  export const getTrainerCertificate = (cred) => {
    return (dispatch) => {
      dispatch({
        type: TRAINER_CERTIFICATE.REQUEST,
      });
      axios
        .request({
          method: "post",
          url: `${APP_URL}/get-trainer-certificate`,
          data: cred,
        })
        .then((res) => {
          dispatch({
            type: TRAINER_CERTIFICATE.GET_TRAINER_CERTIFICATE,
            payload: res.data,
          });
        })
        .catch((error) => {
          dispatch(errorMessage(error, TRAINER_CERTIFICATE.ERROR));
        });
    };
  };
  
  export const updateTrainerCertificate = (cred) => {
    return (dispatch) => {
      dispatch({
        type: TRAINER_CERTIFICATE.REQUEST,
      });
      axios
        .request({
          method: "post",
          url: `${APP_URL}/update-trainer-certificate`,
          data: cred,
        })
        .then((res) => {
          dispatch({
            type: TRAINER_CERTIFICATE.UPDATE_TRAINER_CERTIFICATE,
            payload: res.data,
          });
        })
        .catch((error) => {
          dispatch(errorMessage(error, TRAINER_CERTIFICATE.ERROR));
        });
    };
  };


const TAG = "CERTIFICATE";
export const TRAINER_CERTIFICATE = {
    ERROR: TAG + "ERROR",
    REQUEST: TAG + "REQUEST",
    ADD_TRAINER_CERTIFICATE: TAG + "ADD_TRAINER_CERTIFICATE",
    UPDATE_TRAINER_CERTIFICATE: TAG + "UPDATE_TRAINER_CERTIFICATE",
    GET_TRAINER_CERTIFICATE: TAG + "GET_TRAINER_CERTIFICATE",
    DELETE_TRAINER_CERTIFICATE: TAG + "DELETE_TRAINER_CERTIFICATE",
    GET_LIST_TRAINER_CERTIFICATE: TAG + "GET_LIST_TRAINER_CERTIFICATE",
   }